import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './stores/authStore';
import { useSocketStore } from './stores/socketStore';

// Pages
import HomePage from './pages/HomePage';
import CreateRoomPage from './pages/CreateRoomPage';
import RoomPage from './pages/RoomPage';
import GamePage from './pages/GamePage';
import ProfilePage from './pages/ProfilePage';
import LeaderboardPage from './pages/LeaderboardPage';
import PremiumPage from './pages/PremiumPage';
import GamesPage from './pages/GamesPage';
import EventPage from './pages/EventPage';

// Components
import Layout from './components/Layout';
import Particles from './components/Particles';

function App() {
  const { checkAuth } = useAuthStore();
  const { connect } = useSocketStore();
  
  useEffect(() => {
    // Vérifier l'authentification au chargement (synchrone, lit les params URL)
    checkAuth();
    
    // Attendre un tick pour que le state zustand soit mis à jour
    // avant de connecter le socket qui lira le state
    setTimeout(() => {
      connect();
    }, 100);
  }, [checkAuth, connect]);
  
  return (
    <>
      <Particles />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/games" element={<GamesPage />} />
          <Route path="/create" element={<CreateRoomPage />} />
          <Route path="/room/:code" element={<RoomPage />} />
          <Route path="/game/:code" element={<GamePage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/profile/:id" element={<ProfilePage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
          <Route path="/premium" element={<PremiumPage />} />
          <Route path="/event" element={<EventPage />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;
